var exports = {
  "EU": "CellFrame__GHvvbb",
  "XW": "DropTargetRing__AnP-NK",
  "nB": "Body__yg6wuR",
  "xx": "ScrollFades__5zP0QA",
  "CW": "Cards__Iz2lWl",
  "Up": "CardRoom__B0WA0R",
  "_W": "HeldCard__EG5oE-",
};

module.exports = exports;
